import { put, select, all
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actionTypes from '../actions/actionTypes';
import * as actions from '../actions';

export function* createIOTssidNetworkSaga(action) {
    const masterAcct = yield sessionStorage.getItem('masterAcct');
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    // console.log(sessionToken, action, "tesr")
    if (sessionToken) {
      try {
       let response = {};
       yield put(({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: true }));
        if(action.info.method === 'patch'){
           response = yield axios.patch(
            '/updateIOTNetwork',
            {
              wifiSsidName: action.info.ssid,
              wifiSsidPassphrase: action.info.ssidPassword,
              enabled: action.info.enabled,
              broadcast: action.info.ssidBroadcast,
              ssidnumberOfUnits: action.info.numberOfUnits || 0,
              numberOfBuildings: action.info.numberOfBuildings || 0,
              wifiType: action.info.wifiType,
              masterAcct,
              configType: action.info.configType
            }
          )
        //  console.log(response, "response 123")
          if(response.data?.status === 200){
            yield put(actions.createIOTssidNetworkSuccess(response.data))
            yield put(actions.getIOTssidNetworkDetails(action.info.wifiType));
          } else if (response.data?.status === 404) {
            yield put(actions.createIOTssidNetworkFailed({message: response.data?.message}));
          } else {
            yield put(actions.createIOTssidNetworkFailed());
          }
          yield put(({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: false }));
        } else {
           response = yield axios.post(
            '/createIOTNetwork',
            {
              wifiSsidName: action.info.ssid,
              wifiSsidPassphrase: action.info.ssidPassword,
              enabled: action.info.enabled,
              broadcast: action.info.ssidBroadcast,
              ssidnumberOfUnits: action.info.numberOfUnits || 0,
              numberOfBuildings: action.info.numberOfBuildings || 0,
              wifiType: action.info.wifiType,
              masterAcct,
              configType: action.info.configType
            }
          )
          // console.log(response, "response 1234")
          if(response.data?.status === 200){
            yield put(actions.createIOTssidNetworkSuccess(response.data))
            yield put(actions.getIOTssidNetworkDetails(action.info.wifiType));
          } else if(response.data?.status === 404){
            yield put(actions.createIOTssidNetworkFailed({message: response.data?.message}));
          } else {
            yield put(actions.createIOTssidNetworkFailed());
          }
          yield put(({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: false }));
        }

      } catch (error) {
        // console.log("testhh", error)
        yield put(actions.createIOTssidNetworkFailed());
        yield put(({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: false }));
      }
    } else {
      // console.log('NO TOKEN');
      yield put(actions.setSecondSsidInfoFailed());
    }
  }

  export function* getIOTssidNetworkDetailsSaga(action) {
    const masterAcct = yield sessionStorage.getItem('masterAcct');
    const wifiType = action.wifiType;
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    // console.log("GET_IOT_SSID_NETWORK_DETAILS", sessionToken)
    if (sessionToken) {
      try {
        yield put({type: actionTypes.GET_IOT_SSID_NETWORK_LOADING})
       const response = yield axios.get(
          '/getIOTNetwork',
          {
         params: {
          wifiType : wifiType,
          masterAcct
        }
      }
        )

        if (response?.data?.status === 200) {
          yield put(actions.getIOTssidNetworkSuccess(response?.data));
        } else {
          yield put(actions.getIOTssidNetworkFailed());
        }
      } catch (error) {
        yield put(actions.getIOTssidNetworkFailed());
      }
    }
  }

  export function* getallIOTssidNetworkDetailsSaga(action) {
    const masterAcct = yield sessionStorage.getItem('masterAcct');
    const wifiType = action.wifiType;
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    if (sessionToken) {
      try {
        yield put({type: actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING})
       const response = yield axios.get(
          '/getallIOTssidNetwork',
         {
          wifiType : wifiType,
          masterAcct: masterAcct
         }
        )
        if (response?.status === 200) {
          yield put(actions.getIOTssidNetworkSuccess(response?.data));
        } else {
          yield put(actions.getIOTssidNetworkFailed());
        }
      } catch (error) {
        yield put(actions.getIOTssidNetworkFailed());
      }
    }
  }

export function* getNetworksSaga() {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_NETWORKS_LOADING });
      const response = yield axios.get('/getNetworks', { params: { masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getNetworksSuccess(response.data));
        const data = response.data;
        const networks = Object.keys(data)
          .filter(key => !isNaN(key))
          .map(key => data[key]);
        if (networks.length > 0) {
          const currentSelected = yield select(state => state.propertyIOTNetwork.selectedNetwork);
          const currentType = currentSelected?.wifiType;
          const matchedNetwork = currentType && networks.find(n => n.wifiType === currentType);
          const defaultNetwork = matchedNetwork || networks.find(n => n.wifiType === 'IOT') || networks[0];
          yield put(actions.setSelectedNetwork(defaultNetwork));
        }
      } else {
        yield put(actions.getNetworksFail());
      }
    } catch (error) {
      yield put(actions.getNetworksFail());
    }
  }
}

export function* getNetworkDevicesSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_NETWORK_DEVICES_LOADING });
      const response = yield axios.get('/getIOTNetworkDevices', {
        params: { wifiType: action.payload, masterAcct },
        validateStatus: () => true
      });
      if (response?.data?.status === 200) {
        yield put(actions.getNetworkDevicesSuccess(response.data.devices || []));
      } else {
        yield put(actions.getNetworkDevicesFail({
          status: response?.data?.status || response?.status,
          message: response?.data?.message || response?.data?.error || 'An error occurred'
        }));
      }
    } catch (error) {
      const status = error?.response?.status || 0;
      yield put(actions.getNetworkDevicesFail({
        status: status,
        message: error?.response?.data?.message || 'An error occurred'
      }));
    }
  }
}

export function* updateNetworkSaga(action) {
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.UPDATE_NETWORK_LOADING });
      const response = yield axios.patch('/updateNetwork', {
        ...action.payload,
        configType: action.payload.configType,
      });
      if (response?.data?.status === 200) {
        yield put(actions.updateNetworkSuccess(response.data));
        yield put(actions.getNetworks());
      } else {
        yield put(actions.updateNetworkFail());
      }
    } catch (error) {
      yield put(actions.updateNetworkFail());
    }
  }
}

export function* deleteNetworkSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.DELETE_NETWORK_LOADING });
      const response = yield axios.delete('/deleteIOTNetwork', { data: { ...action.payload, bulkMasterAccount: masterAcct } });
      if (response?.data?.status === 204) {
        yield put(actions.deleteNetworkSuccess());
        yield put(actions.getNetworks());
      } else {
        yield put(actions.deleteNetworkFail());
      }
    } catch (error) {
      yield put(actions.deleteNetworkFail());
    }
  }
}

export function* getIOTNetworkDevicesSaga(action) {
    const masterAcct = yield sessionStorage.getItem('masterAcct');
  const wifiType = action.payload.wifiType;
  const page = action.payload.page;
    const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
       const response = yield axios.get(
          `/getIOTNetworkDevices?wifiType=${"IOT"}&page=${page}`,
         {
          wifiType : wifiType,
           masterAcct: masterAcct
         }
        )
      if (response?.status === 200) {
          yield put(actions.getIOTssidNetworkDevicesSuccess(response?.data));
        } else {
          yield put(actions.getIOTssidNetworkDevicesFailed());
        }
      } catch (error) {
        yield put(actions.getIOTssidNetworkDevicesFailed());
      }
    }
  }
